// chatDensity.js — pure read/write/normalize for the Code chat density pref.
//
// Sprint tier-s-chat E2-WS1-T01. The density toggle (compact | comfortable)
// already lived inline in ExecutionChat; this extracts the localStorage +
// event contract into a side-effect-light, testable helper so the component
// stays a thin consumer. Reuses the EXISTING chatCompactUi key/event so there
// is a single density system (no parallel store).
//
// - compact     = tighter padding/line-height → more text on screen
// - comfortable = default (more breathing room, glass surfaces relaxed)
// - detailed    = Cursor-parity "Detailed" level (design-uplift sprint): tool
//                 cards open by default, output un-clamped, work-summaries
//                 expanded. Layout matches comfortable (it is "not compact"),
//                 so only ToolCallBlock/WorkSummary opt into the extra detail.
//
// Ordered least → most detail; the toolbar button cycles through them and the
// Appearance panel selects directly. Default stays `comfortable` so a user who
// never touches it sees the exact prior app.

import { CHAT_DENSITY_KEY, CHAT_DENSITY_EVENT } from './chatCompactUi.js';

export { CHAT_DENSITY_KEY, CHAT_DENSITY_EVENT };

export const DENSITIES = ['compact', 'comfortable', 'detailed'];
const DEFAULT_DENSITY = 'comfortable';

export const DENSITY_LABELS = {
  compact: 'Compacto',
  comfortable: 'Confortável',
  detailed: 'Detalhado',
};

export function normalizeDensity(value) {
  return DENSITIES.includes(value) ? value : DEFAULT_DENSITY;
}

export function getDensity() {
  try {
    return normalizeDensity(localStorage.getItem(CHAT_DENSITY_KEY));
  } catch {
    return DEFAULT_DENSITY;
  }
}

export function setDensity(value) {
  const next = normalizeDensity(value);
  try {
    localStorage.setItem(CHAT_DENSITY_KEY, next);
  } catch {
    /* private mode — keep going so the in-memory toggle still works */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CHAT_DENSITY_EVENT, { detail: next }));
  }
  return next;
}

export function nextDensity(value) {
  const i = DENSITIES.indexOf(normalizeDensity(value));
  return DENSITIES[(i + 1) % DENSITIES.length];
}
